"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.HEADER_HEIGHT=void 0;/** @format */var HEADER_HEIGHT=exports.HEADER_HEIGHT="7rem";